import React from 'react';
import PropTypes from 'prop-types';
import Component from 'components/component';

export default class DField extends Component {

    static propTypes = {
        label: PropTypes.string,
        id: PropTypes.string,
        modCheckbox: PropTypes.bool,
    }

    render() {

        const className = this.classList(
            'd-field',
            this.props.bss && 'd-field--bss',
            this.props.bssFieldsPrivacy && 'bss-fields-privacy'
        )

        const leftClassName = this.classList(
            'd-field-left',
            this.props.modCheckbox && 'd-field-left--checkbox'
        )

        const rightClassName = this.classList(
            'd-field-right'
        )

        const labelClassName = this.classList(
            'label',
            this.props.light && 'label--light'
        )

        return (
            <div className={className}>
                <div className={leftClassName}>
                    <label htmlFor={this.props.id} className={labelClassName}>{this.props.label}</label>
                </div>
                <div className={rightClassName}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}
